<input
  type="text"
  [formControl]="formControl"
  class="hmm-input tw-w-full"
  [formlyAttributes]="field"
/>
